export default __webpack_public_path__ + "static/media/supportIcon.53251b80.svg";